// JsFromRoutes CacheKey 8723fdc390982d5b3675f2e27ad81c0d
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  index: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/menus"),
  create: /* #__PURE__ */ definePathHelper("post", "/api/:venue_slug/menus"),
  show: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/menus/:id"),
  update: /* #__PURE__ */ definePathHelper("patch", "/api/:venue_slug/menus/:id"),
  destroy: /* #__PURE__ */ definePathHelper("delete", "/api/:venue_slug/menus/:id"),
}
